<div class="page-header d-print-none" aria-label="Page header">
  <div class="container-xl">
    <div class="row g-2 align-items-center mt-2 mb-0">
      <div class="col">
        <div class="page-pretitle">{{ pretitle }}</div>
        <h2 class="page-title">{{ title }}</h2>
      </div>
      <div class="col-auto ms-auto d-print-none">
        <div class="btn-list">
          <ng-content select="[settings-actions]"></ng-content>
          <button
            *ngIf="formId"
            class="btn btn-primary"
            type="submit"
            [attr.form]="formId"
            [disabled]="pending"
          >
            {{ saveLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
